var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ghost-resizable",style:(_vm.cssVars)},[_c('vue-resizable',{attrs:{"minWidth":_vm.cardWidths[0].value - 20,"width":_vm.containerWidth,"active":['r'],"customTrigger":_vm.triggerKey},on:{"resize:move":_vm.onResizeMove,"resize:end":_vm.onResizeEnd}},[_c('div',{staticClass:"resizable-content"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }